export default __webpack_public_path__ + "307a97b7a15e6693c40e7c4fb22fb484.pdf";